<template>
  <section class="registrationPrompt__Inner">
    <p class="registrationPrompt__Route">
      {{ $store.getters.getStringTranslation('alreadyHaveAcc') }}
      <router-link :to="{ name: 'Login' }">{{ $store.getters.getStringTranslation('signIn') }}</router-link>
    </p>

    <h1 class="registrationPrompt__Title">{{ $store.getters.getStringTranslation('orgInv') }}</h1>
    <p class="registrationPrompt__Lead">{{ $store.getters.getStringTranslation('choosePassAllSet') }}</p>

    <form @submit.prevent="register()">
      <p>
        <label class="formLabel" for="password">{{ $store.getters.getStringTranslation('choosePass') }}</label>
        <input
          required
          class="formInput"
          type="password"
          autocomplete="new-password"
          id="password"
          v-model="registerData.password"
        />
      </p>

      <p v-if="success.text !== ''" class="message--Success" v-html="success.text"></p>

      <div class="registrationPrompt__Submit">
        <p v-html="$store.getters.getStringTranslation('termsAndConditions')">
          By clicking <strong>Register</strong> you agree to Motyrõ's
          <a target="_blank" href="https://peopleoverprof.it/terms-conditions">Terms of Service</a>
        </p>
        <p>
          <button class="button--Registration" type="submit">
            {{ $store.getters.getStringTranslation('register') }}
          </button>
        </p>
      </div>

      <error-prompt class="error--Form" :errors="errors.user"></error-prompt>
    </form>
    <loader class="imageLoader" :loading="loading" />
  </section>
</template>

<script>
import HTTP from '@/http-common.js'

import Loader from '@/components/partials/Loader.vue'
import ErrorPrompt from '@/components/editor/ErrorPrompt.vue'

export default {
  name: 'RegisterInvite',
  components: {
    Loader,
    ErrorPrompt,
  },
  data() {
    return {
      loading: false,
      registerData: {
        password: '',
        token: this.$route.params.id,
      },
      errors: {
        user: [],
      },
      success: {
        text: '',
        status: false,
      },
    }
  },
  methods: {
    register() {
      this.loading = true
      HTTP.post('signup_org_inv', this.registerData)
        .then(() => {
          this.success.text = 'All done. Your account has been created. You will be redirected to login.'
          this.success.status = true
          this.loading = false

          setTimeout(() => {
            this.$router.push({ name: 'Login' })
          }, 3000)
        })
        .catch((e) => {
          this.errors.user = e.response.data
          this.loading = false
        })
    },
  },
}
</script>
